/* TRANSLATIONS */
export const GET_TRANSLATIONS = "GET_TRANSLATIONS"
export const GET_TRANSLATIONS_SUCCESS = "GET_TRANSLATIONS_SUCCESS"
export const GET_TRANSLATIONS_FAIL = "GET_TRANSLATIONS_FAIL"